import { CdkStepper } from "@angular/cdk/stepper";
import { Component } from "@angular/core";

@Component({
 selector: 'cdk-customer-stepper',
 templateUrl: './cdk-customer-stepper.html',
 styleUrls: ['./cdk-customer-stepper.scss'],
 providers: [{ provide: CdkStepper, useExisting: CustomerStepper }],
})
export class CustomerStepper extends CdkStepper {
 label: boolean = true;

 wow(event: any) {
  let w = document.getElementById("stepper")!.style.width;

  document.getElementById("stepper")!.style.width = "10%";
  document.getElementById("customStepper2")!.classList.replace("relaxed", "focus");
  this.label = !this.label;
  console.log(w);
  if (w === "10%") {
   document.getElementById("stepper")!.style.width = "25%";
   document.getElementById("customStepper2")!.classList.replace("focus", "relaxed");
  }

 }
 selectStepByIndex(index: number): void {
  this.selectedIndex = index;
 }
}

